module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "crop-editor px-0 py-0"
  }, [_c('v-container', {
    staticClass: "crop-editor-content"
  }, [_c('v-row', {
    staticClass: "custom-scroll-bar crop-editor-row",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "text-align": "-webkit-center"
    },
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-img', {
    attrs: {
      "max-height": "124",
      "max-width": "124",
      "src": require('@/assets/min-lot.png')
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_c('v-form', {
    ref: "cropForm",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.devices,
      "item-text": "campaign.entityName",
      "item-value": "id",
      "multiple": "",
      "label": _vm.$t('AddCrop.cropDevices'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "no-data-text": _vm.$t('AddCrop.noDevices'),
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var active = ref.active;
        var item = ref.item;
        var attrs = ref.attrs;
        var on = ref.on;

        return [_c('v-list-item', _vm._g(_vm._b({
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var active = ref.active;

              return [_c('v-list-item-action', [_c('v-checkbox', {
                attrs: {
                  "input-value": active
                }
              })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('v-row', {
                attrs: {
                  "no-gutters": "",
                  "align": "center"
                }
              }, [_c('span', [_vm._v(_vm._s(item.campaign.entityName) + " - " + _vm._s(_vm.getEquipmentTypeLabel(item.equipment.type)))])])], 1)], 1)]
            }
          }], null, true)
        }, 'v-list-item', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.newCropData.devices),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "devices", $$v)
      },
      expression: "newCropData.devices"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddCrop.cropName')) + " *"),
      "title": ((_vm.$t('AddCrop.cropName')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [_vm.rules.fieldRequired],
      "required": "",
      "maxlength": "30",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.newCropData.name),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "name", $$v)
      },
      expression: "newCropData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.cropTypes,
      "label": ((_vm.$t('AddCrop.cropType')) + " *"),
      "title": ((_vm.$t('AddCrop.cropType')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [_vm.rules.fieldRequired, _vm.rules.arrayFieldValidation],
      "required": "",
      "multiple": "",
      "clearable": "",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.newCropData.type),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "type", $$v)
      },
      expression: "newCropData.type"
    }
  })], 1), _vm._v(" "), (!_vm.isNewCrop) ? _c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.fields,
      "item-text": "name",
      "item-value": "id",
      "label": ((_vm.$t('AddCrop.cropField')) + " *"),
      "title": ((_vm.$t('AddCrop.cropField')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [_vm.rules.fieldRequired],
      "required": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "append-item",
      fn: function() {
        return [_c('v-list-item', {
          on: {
            "click": _vm.addNewField
          }
        }, [_c('v-list-item-title', {
          staticClass: "add-field-btn"
        }, [_vm._v("\n                      " + _vm._s(_vm.$t('AddCrop.addNewField')) + "\n                    ")])], 1)]
      },
      proxy: true
    }], null, false, 2880768088),
    model: {
      value: (_vm.newCropData.field),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "field", $$v)
      },
      expression: "newCropData.field"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": ("" + (_vm.$t('AddCrop.cropSowingDate'))),
            "title": ("" + (_vm.$t('AddCrop.cropSowingDate'))),
            "append-icon": "mdi-calendar",
            "readonly": "",
            "outlined": "",
            "background-color": "#FFF",
            "color": "#0098E1",
            "clearable": "",
            "hide-details": "auto"
          },
          model: {
            value: (_vm.newCropData.sowingDate),
            callback: function($$v) {
              _vm.$set(_vm.newCropData, "sowingDate", $$v)
            },
            expression: "newCropData.sowingDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "#0098E1",
      "locale": "es-AR"
    },
    on: {
      "input": function($event) {
        _vm.dateMenu = false
      }
    },
    model: {
      value: (_vm.auxDate),
      callback: function($$v) {
        _vm.auxDate = $$v
      },
      expression: "auxDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddCrop.cropArea')) + " *"),
      "title": ((_vm.$t('AddCrop.cropArea')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [_vm.rules.fieldRequired, _vm.rules.numberValidation],
      "required": "",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.newCropData.area),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "area", _vm._n($$v))
      },
      expression: "newCropData.area"
    }
  })], 1)], 1), _vm._v(" "), (_vm.newCropData.shapeType === 3) ? _c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "8",
      "sm": "4"
    }
  }, [_c('v-btn', {
    staticClass: "toggle-btn",
    attrs: {
      "elevation": "0",
      "color": "#0098E1",
      "block": ""
    },
    on: {
      "click": _vm.toggleMap
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cropMapSelection ? _vm.$t('AddCrop.hideMap') : _vm.$t('AddCrop.showMap')) + "\n              ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "8",
      "sm": "4"
    }
  }, [_c('v-btn', {
    staticClass: "toggle-btn",
    attrs: {
      "elevation": "0",
      "color": "#0098E1",
      "block": ""
    },
    on: {
      "click": _vm.toggleCoordinates
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showCoordinates ? _vm.$t('AddCrop.hideCoordinates') : _vm.$t('AddCrop.showCoordinates')) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.newCropData.shapeType === 3) ? _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cropMapSelection),
      expression: "cropMapSelection"
    }],
    staticClass: "px-2 my-3",
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('CropMap', {
    attrs: {
      "cropMapSelection": _vm.cropMapSelection,
      "cropData": _vm.newCropData
    },
    on: {
      "update:cropMapSelection": function($event) {
        _vm.cropMapSelection = $event
      },
      "update:crop-map-selection": function($event) {
        _vm.cropMapSelection = $event
      },
      "update:cropData": function($event) {
        _vm.newCropData = $event
      },
      "update:crop-data": function($event) {
        _vm.newCropData = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.newCropData.shapeType === 1) ? _c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddCrop.centerCoordinates')) + " *"),
      "title": ((_vm.$t('AddCrop.centerCoordinates')) + " *"),
      "validate-on-blur": "",
      "outlined": "",
      "hint": ("" + (_vm.$t('AddCrop.coordinatesHint'))),
      "persistent-hint": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon],
      "hide-details": "auto"
    },
    on: {
      "blur": _vm.handleCenterCoordinatesBlur
    },
    model: {
      value: (_vm.newCropData.centerCoordinatesString),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "centerCoordinatesString", $$v)
      },
      expression: "newCropData.centerCoordinatesString"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddDevice.radius')) + " *"),
      "title": ((_vm.$t('AddDevice.radius')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "rules": [_vm.rules.fieldRequired, _vm.rules.numberValidation],
      "hide-details": "auto"
    },
    model: {
      value: (_vm.newCropData.radius),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "radius", _vm._n($$v))
      },
      expression: "newCropData.radius"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "my-3 px-2",
    attrs: {
      "cols": "12",
      "sm": "7"
    }
  }, [_c('v-row', [_c('a', {
    staticClass: "advanced-cfg float-left",
    on: {
      "click": function($event) {
        _vm.startAndEndPointsFlag = !_vm.startAndEndPointsFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.startAndEndPointsFlag ? '-' : '+') + " " + _vm._s(_vm.$t('AddDevice.startAndEndPoints')))])]), _vm._v(" "), (_vm.startAndEndPointsFlag) ? [_c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "px-0 py-0",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddDevice.startCoordinates')) + " *"),
      "title": ((_vm.$t('AddDevice.startCoordinates')) + " *"),
      "validate-on-blur": "",
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "hide-details": "auto",
      "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon]
    },
    on: {
      "blur": function($event) {
        return _vm.handleCropCoordinatesBlur(_vm.newCropData.startCoordinatesString, 'start')
      }
    },
    model: {
      value: (_vm.newCropData.startCoordinatesString),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "startCoordinatesString", $$v)
      },
      expression: "newCropData.startCoordinatesString"
    }
  })], 1), _vm._v(" "), (_vm.newCropData.startAngle !== undefined) ? _c('v-col', {
    staticClass: "pl-2 pr-0 angle-hint",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                          " + _vm._s(this.$t('AddCrop.angleHint', {
    angle: _vm.newCropData.startAngle.toFixed(0)
  })) + "\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-checkbox', {
    staticClass: "my-5",
    attrs: {
      "label": _vm.$t('AddDevice.endPointEqualToStart'),
      "hide-details": ""
    },
    model: {
      value: (_vm.endPointEqualToStart),
      callback: function($$v) {
        _vm.endPointEqualToStart = $$v
      },
      expression: "endPointEqualToStart"
    }
  }), _vm._v(" "), (!_vm.endPointEqualToStart) ? _c('v-row', [_c('v-col', {
    staticClass: "px-0 py-0",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "label": ((_vm.$t('AddDevice.endCoordinates')) + " *"),
      "title": ((_vm.$t('AddDevice.endCoordinates')) + " *"),
      "validate-on-blur": "",
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "hide-details": "auto",
      "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon]
    },
    on: {
      "blur": function($event) {
        return _vm.handleCropCoordinatesBlur(_vm.newCropData.endCoordinatesString, 'end')
      }
    },
    model: {
      value: (_vm.newCropData.endCoordinatesString),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "endCoordinatesString", $$v)
      },
      expression: "newCropData.endCoordinatesString"
    }
  })], 1), _vm._v(" "), (_vm.newCropData.endAngle !== undefined) ? _c('v-col', {
    staticClass: "pl-2 pr-0 angle-hint",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                          " + _vm._s(this.$t('AddCrop.angleHint', {
    angle: _vm.newCropData.endAngle !== _vm.newCropData.startAngle || _vm.newCropData.startAngle !== 0 ? _vm.newCropData.endAngle.toFixed(0) : 360
  })) + "\n                        ")]) : _vm._e()], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('v-col', {
    staticClass: "px-5 my-5",
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  }, [_c('PivotCropArea', {
    attrs: {
      "cropData": _vm.newCropData
    }
  })], 1)], 1)], 1) : (_vm.newCropData.shapeType === 2) ? _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "my-3 px-2 py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "label": ((_vm.$t('AddDevice.startCoordinates')) + " *"),
      "title": ((_vm.$t('AddDevice.startCoordinates')) + " *"),
      "validate-on-blur": "",
      "outlined": "",
      "hint": ("" + (_vm.$t('AddDevice.coordinatesHint'))),
      "persistent-hint": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon],
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.handleCropCoordinatesBlur(_vm.newCropData.startCoordinatesString, 'start')
      }
    },
    model: {
      value: (_vm.newCropData.startCoordinatesString),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "startCoordinatesString", $$v)
      },
      expression: "newCropData.startCoordinatesString"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "my-3 px-2 py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "label": ((_vm.$t('AddDevice.endCoordinates')) + " *"),
      "title": ((_vm.$t('AddDevice.endCoordinates')) + " *"),
      "validate-on-blur": "",
      "outlined": "",
      "hint": ("" + (_vm.$t('AddDevice.coordinatesHint'))),
      "persistent-hint": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "required": "",
      "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon],
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.handleCropCoordinatesBlur(_vm.newCropData.endCoordinatesString, 'end')
      }
    },
    model: {
      value: (_vm.newCropData.endCoordinatesString),
      callback: function($$v) {
        _vm.$set(_vm.newCropData, "endCoordinatesString", $$v)
      },
      expression: "newCropData.endCoordinatesString"
    }
  })], 1)], 1)], 1) : (_vm.newCropData.shapeType === 3 && _vm.showCoordinates) ? _c('div', [_vm._l((_vm.cropIRPoints), function(point, pointIndex) {
    return _c('v-row', {
      key: ("point_" + pointIndex),
      attrs: {
        "justify": "center"
      }
    }, [_c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "9"
      }
    }, [_c('v-text-field', {
      staticClass: "mb-2",
      attrs: {
        "label": ((_vm.$t('AddDevice.coordinates')) + " *"),
        "title": ((_vm.$t('AddDevice.coordinates')) + " *"),
        "validate-on-blur": "",
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "hint": ("" + (_vm.$t('FieldEditor.coordinatesHint'))),
        "persistent-hint": "",
        "required": "",
        "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon],
        "hide-details": "auto"
      },
      on: {
        "blur": function($event) {
          return _vm.handleIRCropCoordinatesBlur(point.coordinatesString, pointIndex)
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function() {
          return [_c('p', {
            staticClass: "mb-0 mr-1 text-end"
          }, [_vm._v("\n                          " + _vm._s(_vm.getPointLetter(pointIndex)) + "\n                        ")])]
        },
        proxy: true
      }], null, true),
      model: {
        value: (point.coordinatesString),
        callback: function($$v) {
          _vm.$set(point, "coordinatesString", $$v)
        },
        expression: "point.coordinatesString"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('v-btn', {
      attrs: {
        "fab": "",
        "small": "",
        "elevation": "1",
        "color": "#FFF"
      },
      on: {
        "click": function($event) {
          return _vm.deleteIRPoint(pointIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("remove")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-row', {
    staticClass: "justify-start",
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "x-small": "",
      "elevation": "1",
      "color": "#FFF"
    },
    on: {
      "click": _vm.addIRPoint
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.addPoint')))])], 1)], 2) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3 crop-editor-button-row"
  }, [_c('v-col', {
    staticClass: "align-center",
    attrs: {
      "cols": "12",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-btn', {
    staticClass: "form-confirmation-button",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.register')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1486b54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/CropEditor.vue
// module id = 1743
// module chunks = 0